export default __webpack_public_path__ + "static/media/web.ccd68c7c.svg";